import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, NgModule, Optional, PLATFORM_ID } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

var LoggerConfig = (function () {
    function LoggerConfig() {
    }
    return LoggerConfig;
}());
var NgxLoggerLevel = {};
NgxLoggerLevel.TRACE = 0;
NgxLoggerLevel.DEBUG = 1;
NgxLoggerLevel.INFO = 2;
NgxLoggerLevel.LOG = 3;
NgxLoggerLevel.WARN = 4;
NgxLoggerLevel.ERROR = 5;
NgxLoggerLevel.OFF = 6;
NgxLoggerLevel[NgxLoggerLevel.TRACE] = "TRACE";
NgxLoggerLevel[NgxLoggerLevel.DEBUG] = "DEBUG";
NgxLoggerLevel[NgxLoggerLevel.INFO] = "INFO";
NgxLoggerLevel[NgxLoggerLevel.LOG] = "LOG";
NgxLoggerLevel[NgxLoggerLevel.WARN] = "WARN";
NgxLoggerLevel[NgxLoggerLevel.ERROR] = "ERROR";
NgxLoggerLevel[NgxLoggerLevel.OFF] = "OFF";
var Levels = [
    'TRACE',
    'DEBUG',
    'INFO',
    'LOG',
    'WARN',
    'ERROR',
    'OFF'
];
var NGXLogger = (function () {
    /**
     * @param {?} http
     * @param {?} platformId
     * @param {?} options
     */
    function NGXLogger(http$$1, platformId, options) {
        this.http = http$$1;
        this.platformId = platformId;
        this.options = options;
        if (!this.options) {
            this.options = {
                level: NgxLoggerLevel.OFF,
                serverLogLevel: NgxLoggerLevel.OFF
            };
        }
        this._serverLogLevel = this.options.serverLogLevel;
        this._clientLogLevel = this.options.level;
        this._isIE = isPlatformBrowser(platformId) &&
            !!(navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.match(/Trident\//) || navigator.userAgent.match(/Edge\//));
    }
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.trace = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.TRACE, true, message, additional);
    };
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.debug = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.DEBUG, true, message, additional);
    };
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.info = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.INFO, true, message, additional);
    };
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.log = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.LOG, true, message, additional);
    };
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.warn = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.WARN, true, message, additional);
    };
    /**
     * @param {?} message
     * @param {...?} additional
     * @return {?}
     */
    NGXLogger.prototype.error = function (message) {
        var additional = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additional[_i - 1] = arguments[_i];
        }
        this._log(NgxLoggerLevel.ERROR, true, message, additional);
    };
    /**
     * @return {?}
     */
    NGXLogger.prototype._timestamp = function () {
        return new Date().toISOString();
    };
    /**
     * @param {?} level
     * @param {?} message
     * @param {?} additional
     * @return {?}
     */
    NGXLogger.prototype._logOnServer = function (level, message, additional) {
        var _this = this;
        if (!this.options.serverLoggingUrl) {
            return;
        }
        // if the user provides a serverLogLevel and the current level is than that do not log
        if (level < this._serverLogLevel) {
            return;
        }
        var /** @type {?} */ headers = new HttpHeaders().set('Content-Type', 'application/json');
        this.http.post(this.options.serverLoggingUrl, {
            level: Levels[level],
            message: message,
            additional: additional,
            timestamp: this._timestamp()
        }, { headers: headers })
            .subscribe(function (res) { return null; }, function (error) { return _this._log(NgxLoggerLevel.ERROR, false, 'FAILED TO LOG ON SERVER'); });
    };
    /**
     * @param {?} level
     * @param {?} message
     * @param {?} additional
     * @return {?}
     */
    NGXLogger.prototype._logIE = function (level, message, additional) {
        switch (level) {
            case NgxLoggerLevel.WARN:
                console.warn.apply(console, [this._timestamp() + " [" + Levels[level] + "] ", message].concat(additional));
                break;
            case NgxLoggerLevel.ERROR:
                console.error.apply(console, [this._timestamp() + " [" + Levels[level] + "] ", message].concat(additional));
                break;
            case NgxLoggerLevel.INFO:
                console.info.apply(console, [this._timestamp() + " [" + Levels[level] + "] ", message].concat(additional));
                break;
            default:
                console.log.apply(console, [this._timestamp() + " [" + Levels[level] + "] ", message].concat(additional));
        }
    };
    /**
     * @param {?} level
     * @param {?} logOnServer
     * @param {?} message
     * @param {?=} additional
     * @return {?}
     */
    NGXLogger.prototype._log = function (level, logOnServer, message, additional) {
        if (additional === void 0) { additional = []; }
        if (!message) {
            return;
        }
        // Allow logging on server even if client log level is off
        if (logOnServer) {
            this._logOnServer(level, message, additional);
        }
        // if no message or the log level is less than the environ
        if (level < this._clientLogLevel) {
            return;
        }
        if (typeof message === 'object') {
            try {
                message = JSON.stringify(message, null, 2);
            }
            catch (e) {
                additional = [message].concat(additional);
                message = 'circular object in message. ';
            }
        }
        // Coloring doesn't work in IE
        if (this._isIE) {
            return this._logIE(level, message, additional);
        }
        var /** @type {?} */ color = this._getColor(level);
        console.log.apply(console, ["%c" + this._timestamp() + " [" + Levels[level] + "]", "color:" + color, message].concat(additional));
    };
    /**
     * @param {?} level
     * @return {?}
     */
    NGXLogger.prototype._getColor = function (level) {
        switch (level) {
            case NgxLoggerLevel.TRACE:
                return 'blue';
            case NgxLoggerLevel.DEBUG:
                return 'teal';
            case NgxLoggerLevel.INFO:
            case NgxLoggerLevel.LOG:
                return 'gray';
            case NgxLoggerLevel.WARN:
            case NgxLoggerLevel.ERROR:
                return 'red';
            case NgxLoggerLevel.OFF:
            default:
                return;
        }
    };
    return NGXLogger;
}());
NGXLogger.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NGXLogger.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
    { type: LoggerConfig, decorators: [{ type: Optional },] },
]; };

var NGXLoggerMock = (function () {
    function NGXLoggerMock() {
    }
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.trace = function (message) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.debug = function (message) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.info = function (message) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.log = function (message) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.warn = function (message) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    NGXLoggerMock.prototype.error = function (message) {
    };
    return NGXLoggerMock;
}());
NGXLoggerMock.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NGXLoggerMock.ctorParameters = function () { return []; };

var LoggerModule = (function () {
    function LoggerModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    LoggerModule.forRoot = function (config) {
        return {
            ngModule: LoggerModule,
            providers: [
                { provide: LoggerConfig, useValue: config || {} },
                NGXLogger,
                NGXLoggerMock
            ]
        };
    };
    /**
     * @return {?}
     */
    LoggerModule.forChild = function () {
        return {
            ngModule: LoggerModule,
            providers: [
                NGXLogger,
                NGXLoggerMock
            ]
        };
    };
    return LoggerModule;
}());
LoggerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    HttpClientModule
                ]
            },] },
];
/**
 * @nocollapse
 */
LoggerModule.ctorParameters = function () { return []; };

export { LoggerModule, NGXLoggerMock, LoggerConfig, NgxLoggerLevel, NGXLogger };



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/ngx-logger/index.js
// module id = ../../../../ngx-logger/index.js
// module chunks = vendor